<template>
  <div style="margin: 10px">
    <el-table :data="resultList" max-height="250">
      <el-table-column width="100" label="序号" align="center" type="index" />
      <el-table-column
        label="标题"
        align="center"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column width="180" label="时间" align="center" prop="updateTime" />
      <el-table-column
        width="100"
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="openDialog(scope.row.id)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :pageSizes="[3]"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getInfoList"
    />
    <!--    弹框-->
    <div id="dialog">
      <el-dialog
        width="80%"
        title="气象预报"
        center
        @close="closeDialog()"
        v-if="isShow"
        :visible.sync="isShow"
        :destroy-on-close="true"
        append-to-body
        style="top: 115px; left: 130px"
      >
        <!--        显示内容容器-->
        <div id="html_container" style="width: 100%; height: 100%" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["isToken"],
  data() {
    return {
      resultList: [],
      BASE_URL: "http://cctv.hbrytech.cn:2123/prod-api/",
      isShow: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created() {},
  methods: {
    // 航道通告
    getInfoList() {
      console.log(this.isToken, "isTokenisToken");
      axios({
        url: this.$root.BASE_URL + "/work/notice/wf",
        method: "get",
        params: this.queryParams,
        headers: {
          authorization: this.isToken,
        },
      }).then((res) => {
        this.resultList = res.data.rows;
        this.total = res.data.total;
      });
    },
    openDialog(id) {
      // 开启弹框
      this.isShow = true;
      this.$nextTick(() => {
        // 请求后端获取 详细内容
        axios({
          url: this.$root.BASE_URL + `/work/notice/wf/${id}`,
          method: "get",
          headers: {
            authorization: this.isToken,
          },
        }).then((res) => {
          let dialogDom = document.querySelector("#html_container");
          dialogDom.insertAdjacentHTML("afterbegin", res.data.data.content);
        });
      });
    },
    // closeDialog() {
    //   // 关闭弹框
    //   this.isShow = false;
    // },
  },
};
</script>
<style>

</style>
